export const getLastAccessedInboxId = state => state.unifiedInbox.lastAccessedInboxId;